/* eslint-disable react/prop-types */
import { h } from 'preact';

export const ParselyWrapper = ({ children }) => (
  <div className="c-rail-content c-rail-content--parsely">{children}</div>
);

export const ParselyVideoWrapper = ({ children }) => (
  <div className="c-rail-content c-rail-content--video">{children}</div>
);

export const ParselyBody = ({ children }) => <div className="c-rail-content__body">{children}</div>;

export const ParselyTop = ({ children }) => <div className="c-rail-content__top">{children}</div>;
